export enum SearchFilterField {
  searchWord = 'searchWord',
  isNotEvaluated = 'isNotEvaluated',
  isNeedEvaluation = 'isNeedEvaluation',
  isUnCreated = 'isUnCreated',
  sex = 'sex',
  course = 'course',
  courseInfo = 'courseInfo',
  courseClassInfo = 'courseClassInfo',
  studentCourseByProfessor = 'studentCourseByProfessor',
  chartType = 'chartType',
  chartRound = 'chartRound',
  score = 'score',
  studentUserId = 'studentUserId',
  registrationStatus = 'registrationStatus',
}

export type TSearchFilter = {
  [SearchFilterField.searchWord]?: string | undefined;
  [SearchFilterField.isNotEvaluated]?: boolean | undefined;
  [SearchFilterField.isNeedEvaluation]?: boolean | undefined;
  [SearchFilterField.isUnCreated]?: boolean | undefined;
  [SearchFilterField.sex]?: string | undefined;
  [SearchFilterField.course]?: string | undefined;
  [SearchFilterField.courseInfo]?: string | undefined;
  [SearchFilterField.courseClassInfo]?: string | undefined;
  [SearchFilterField.studentCourseByProfessor]?: string | undefined;
  [SearchFilterField.chartType]?: string | undefined;
  [SearchFilterField.chartRound]?: string | undefined;
  [SearchFilterField.score]?: string | undefined;
  [SearchFilterField.studentUserId]?: string | undefined;
  [SearchFilterField.registrationStatus]?: string | undefined;
};
